import { useEffect, useState, type RefObject } from "react";

// The Figma's scroll threshold: smaller moves are a thumb's jitter, not a direction.
const DIRECTION_THRESHOLD_PX = 8;

function isStuck(element: HTMLElement): boolean {
	const stickyTop = parseFloat(getComputedStyle(element).top) || 0;
	return element.getBoundingClientRect().top <= stickyTop + 1;
}

export function useHideOnScroll(ref: RefObject<HTMLElement | null>): boolean {
	const [hidden, setHidden] = useState(false);

	useEffect(() => {
		let lastY = window.scrollY;

		function onScroll(): void {
			const element = ref.current;
			const y = window.scrollY;
			const delta = y - lastY;
			if (Math.abs(delta) < DIRECTION_THRESHOLD_PX) return;
			lastY = y;
			setHidden(delta > 0 && element !== null && isStuck(element));
		}

		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, [ref]);

	return hidden;
}
